import React from "react";
import { useTranslation } from "react-i18next";

function ValidationResult({ result }) {
  const { t } = useTranslation();
  if (!result) return null;

  const { data, validationResult, usage } = result;
  const isVerified = data.status === "valid";

  const getStatusStyles = () => {
    if (["pobox", "freight", "mailbox"].includes(validationResult.status)) {
      return "bg-red-100 border-l-4 border-red-500 text-red-700";
    }
    if (["rural", "mismatch"].includes(validationResult.status)) {
      return "bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700";
    }
    return isVerified
      ? "bg-green-100 border-l-4 border-green-500 text-green-700"
      : "bg-gray-100 border-l-4 border-gray-500 text-gray-700";
  };

  const getStatusMessage = () => {
    switch (validationResult.status) {
      case "pobox":
        return t("validationResult.pobox");
      case "freight":
        return t("validationResult.freight");
      case "mailbox":
        return t("validationResult.mailbox");
      case "rural":
        return t("validationResult.rural");
      case "mismatch":
        return `${t("validationResult.mismatch")} ${validationResult.warning}`;
      case "invalid":
        return t("validationResult.invalid");
      default:
        return t("validationResult.valid");
    }
  };

  return (
    <div className="mt-4 sm:mt-6 bg-white p-4 sm:p-6 rounded-lg shadow-md w-full max-w-md sm:max-w-lg mx-auto">
      <h3 className="text-lg sm:text-xl font-semibold text-gray-700 mb-3 sm:mb-4">
        {t("validationResult.title")}
      </h3>
      <div className={`border-l-4 p-3 sm:p-4 rounded-md ${getStatusStyles()}`}>
        <p className="font-medium text-sm sm:text-base">{getStatusMessage()}</p>
        <p className="mt-1 sm:mt-2 text-sm sm:text-base">
          <strong>{t("validationResult.formattedAddress")}:</strong>{" "}
          {data.formattedAddress}
        </p>
        {validationResult.warning && validationResult.status !== "mismatch" && (
          <p className="mt-1 sm:mt-2 text-sm sm:text-base">
            <strong>{t("validationResult.warning")}:</strong>{" "}
            {validationResult.warning}
          </p>
        )}
        {validationResult.coordinates && (
          <p className="mt-1 sm:mt-2 text-sm sm:text-base">
            <strong>{t("validationResult.coordinates")}:</strong>{" "}
            {t("validationResult.latitude")}:{" "}
            {validationResult.coordinates.latitude},{" "}
            {t("validationResult.longitude")}:{" "}
            {validationResult.coordinates.longitude}
          </p>
        )}
        <p className="mt-1 sm:mt-2 text-sm sm:text-base">
          <strong>{t("validationResult.provider")}:</strong>{" "}
          {validationResult.provider}
        </p>
        <p className="mt-1 sm:mt-2 text-sm sm:text-base">
          <strong>{t("validationResult.usage")}:</strong> {usage.count}{" "}
          {t("validationResult.validationsUsed")}, {usage.remaining}{" "}
          {t("validationResult.remaining")}
          {usage.isOverLimit && (
            <span className="text-red-700">
              {" "}
              ({t("validationResult.limitExceeded")})
            </span>
          )}
        </p>
      </div>
    </div>
  );
}

export default ValidationResult;